import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { PrimeBroker } from 'api'
import { MultiTextInput, KeyValuePair } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import { createOrganisationPrimeBrokerByIdGetterSelector } from 'selectors/organisationSelectors'
import { noop } from 'lodash'
import { ModalConsumerProps, withModal } from 'view/shared/modal'

export interface ViewPrimeBrokersPanelProps extends ModalConsumerProps {
  // Own Props
  organisationId: string

  // State Props
  getPrimeBrokers: (organisationId: string) => PrimeBroker[]
}

const mapStateToProps = createStructuredSelector({
  getPrimeBrokers: createOrganisationPrimeBrokerByIdGetterSelector
})

export const ViewPrimeBrokersPanelComponent: React.FunctionComponent<ViewPrimeBrokersPanelProps> = props => {
  const { organisationId, getPrimeBrokers } = props

  const primeBrokers = getPrimeBrokers(organisationId)
  const primeBrokerKeyValuePairs: KeyValuePair<string>[] = primeBrokers.map(primeBroker => ({
    key: primeBroker.id,
    value: primeBroker.name
  }))

  return (
    <MultiTextInput
      readOnly={true}
      value={primeBrokerKeyValuePairs}
      getOption={(itemKey: string) => primeBrokers.find(primeBroker => primeBroker.id === itemKey) || null}
      getOptionText={(item: PrimeBroker) => item.name}
      clearButtonLabel={Locale.translate(Translation.SC_REMOVE_PRIME_BROKERS)}
      onUpdate={noop}
    />
  )
}

export const ViewPrimeBrokersPanel = withModal(connect(mapStateToProps)(ViewPrimeBrokersPanelComponent))
